import React, { useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { useDashBoardData } from "../../context/dashboardDataContext/DashboardDataContext";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import { Link } from "react-router-dom";

// const images = [
//   "https://picsum.photos/2000/2000",
//   "https://picsum.photos/3000/2000",
//   "https://picsum.photos/2000/1500",
//   "https://picsum.photos/3000/1500",
//   "https://picsum.photos/1000/2000",
//   "https://picsum.photos/1500/2000",
// ];

const ImageGallery = () => {
  const { imagesUrl } = useDashBoardData();

  const images = imagesUrl;

  const [data, setData] = useState({ img: "", i: 0 });

  const viewImage = (img, i) => {
    // console.log(img, i);
    setData({ img, i });
  };

  const imgAction = (action) => {
    let i = data.i;
    if (action === "next-img") {
      setData({ img: images[i + 1], i: i + 1 });
    }
    if (action === "prev-img") {
      setData({ img: images[i - 1], i: i - 1 });
    }
    if (!action) {
      setData({ img: "", i: 0 });
    }
  };

  return (
    <>
      {data.img && (
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "#000000d6",
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            top: "0",
            left: "0",
          }}
        >
          {" "}
          <button
            onClick={() => imgAction()}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              padding: "0.5rem 1rem",
              fontWeight: "700",
              border: "none",
            }}
          >
            X
          </button>
          <button
            onClick={() => imgAction("prev-img")}
            style={{
              position: "absolute",
              top: "50%",
              left: "10%",
              // padding: "0.5rem 1rem",
              fontWeight: "700",
              height: "40px",
              width: "40px",
              border: "none",
              borderRadius: "50%",
              background: "#cbcbcb",
            }}
          >
            <MdOutlineKeyboardArrowLeft size={22} />
          </button>
          <button
            onClick={() => imgAction("next-img")}
            style={{
              position: "absolute",
              top: "50%",
              right: "10%",
              // padding: "0.5rem 1rem",
              fontWeight: "700",
              height: "40px",
              width: "40px",
              border: "none",
              borderRadius: "50%",
              background: "#cbcbcb",
            }}
          >
            <MdOutlineKeyboardArrowRight size={22} />
          </button>
          <Link to={data.img} target="_blank">
            <img
              src={data.img}
              alt=""
              style={{ height: "auto", maxWidth: "90%", maxHeight: "90%" }}
            />{" "}
          </Link>
        </div>
      )}
      <div style={{ padding: "10px" }}>
        <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 4 }}>
          <Masonry gutter="10px">
            {images.map((image, i) => (
              <img
                key={i}
                src={image}
                style={{
                  width: "100%",
                  display: "block",
                  cursor: "pointer",
                  height: "auto",
                }}
                alt=""
                onClick={() => viewImage(image, i)}
              />
            ))}
          </Masonry>
        </ResponsiveMasonry>
      </div>
    </>
  );
};

export default ImageGallery;
